import * as yup from 'yup'

// D-17: as datas só são exigidas quando o usuário opta por reativar a última avaliação — é o único
// caminho que agenda a régua de cobrança. Reativar apenas o vínculo do fornecedor não tem régua a
// agendar, logo não tem data a pedir, e o back relaxou o validate_dates_presence! do RV-05 na mesma
// medida. Sem o `when` os campos continuariam obrigatórios e travariam o submit com a opção desmarcada.
export const schema = yup.object().shape({
  reactivateLastAudit: yup.boolean(),
  dateToSendEmails: yup
    .date()
    .nullable()
    .typeError('Data inválida')
    .when('reactivateLastAudit', {
      is: true,
      then: yup.date().nullable().typeError('Data inválida').required(),
    }),
  endDate: yup
    .date()
    .nullable()
    .typeError('Data inválida')
    .when('reactivateLastAudit', {
      is: true,
      then: yup
        .date()
        .nullable()
        .typeError('Data inválida')
        .required()
        .min(
          yup.ref('dateToSendEmails'),
          'O prazo de resposta deve ser igual ou posterior à data de envio',
        ),
    }),
})

export default schema
